module.exports = __webpack_public_path__ + "img/web-rsad-denpasar.e891dd77.jpg";